import React from 'react';
import ReactDOM from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import TravelDairy from './index';
import './styles.css';
import AuthProvider from './services/AuthProvider';
import { AuthErrorBoundary } from './components/AuthErrorBoundary';
import { HealthCheckGate } from './components/HealthCheckGate';
import { ResetPasswordPage } from './components/auth/ResetPasswordPage';
import { ConfirmEmailPage } from './components/auth/ConfirmEmailPage';
import { SharedJourneyPage } from './components/journeys/SharedJourneyPage';

const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID as string | undefined;

function withGoogleProvider(children: React.ReactNode) {
  if (!googleClientId) return children;
  return <GoogleOAuthProvider clientId={googleClientId}>{children}</GoogleOAuthProvider>;
}

function App() {
  if (typeof window !== 'undefined') {
    const path = window.location.pathname;
    if (path === '/reset-password') return <ResetPasswordPage />;
    if (path === '/confirm-email') return <ConfirmEmailPage />;
    if (path.startsWith('/j/')) return <SharedJourneyPage />;
  }
  return (
    <AuthErrorBoundary>
      <HealthCheckGate>
        <AuthProvider>
          {withGoogleProvider(<TravelDairy />)}
        </AuthProvider>
      </HealthCheckGate>
    </AuthErrorBoundary>
  );
}

const root = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

ReactDOM.createRoot(document.getElementById('root')!).render(root);
